














import Vue from "vue";
import TheNavigationDrawer from "@/components/TheNavigationDrawer.vue";

export default Vue.extend({
  name: "TheHeader",

  computed: {
    title() {
      const suffix = this.$root.$data.title
        ? " - " + this.$root.$data.title
        : "";
      return `Ressourcenverwaltung in Krisenzeiten${suffix}`;
    }
  },

  components: {
    TheNavigationDrawer
  },

  data: () => ({
    drawer: null
  })
});
